module.exports = __webpack_public_path__ + "static/media/zolaicons.aa0fc978.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/zolaicons.woff2?24613844
// module id = 1669
// module chunks = 49